import { AppBar, Button, Grid, Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';
import { FilterQuery } from './FilterQuery';
import { DataQuery } from './DataQuery';
import {
  ACTIONLIST,
  ReportReducer,
  initialReportState,
} from './Report.reducer';
import { useStoreActions } from 'easy-peasy';
import { globalDateEntity } from '../../constants/applicationConstants';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

export const QueryDetails = ({ data, entityList, associationTypeList }) => {
  if (!data?.title) {
    return null;
  }
  useEffect(()=>{
    return () =>{
      dispatch({type: ACTIONLIST.RESET_TO_INIT})
    }
  }, []);
  const [state, dispatch] = useReducer(ReportReducer, initialReportState);
  const history = useHistory();
  const [reportAction, commonAction] = useStoreActions((actions) => [
    actions.report,
    actions.common,
  ]);
  
  const executeQuery = (type) => {
    if (state.entitySelectedList.length <= 0) {
      commonAction.setSubmitSnackbar({
        status: true,
        messages: 'Please select at least one field to execute the report',
        error: true,
      });
      return;
    } else {
      const query = {};
      query.entity = {};
      query.entity.metafields = [];
      query.associatedentity = {};
      query.entity.type = state.entityType;
      query.associatedentity.type = state.entityAssocationType;
      query.associatedentity.metafields = [];
      state.entitySelectedList.forEach((item) => {
        query.entity.metafields.push(
          item.name.replace('entity-' + state.entityType + '-', ''),
        );
      });
      state.entityAssociationSelectedList.forEach((item) => {
        query.associatedentity.metafields.push(
          item.name.replace('asso-' + state.entityAssocationType + '-', ''),
        );
      });
      query.filters = state.filters.map((filter, index) => {
        let valueOne = filter.value,
          value_2 = null;
        if (index == 0) {
          filter.relation = '';
        }

        if (filter.name?.includes('entity-' + query.entity.type + '-')) {
          filter.entity_type = query.entity.type;
          filter.key = filter.name.replace(
            'entity-' + query.entity.type + '-',
            '',
          );
        } else if (
          filter.name?.includes('asso-' + query.associatedentity.type + '-')
        ) {
          filter.entity_type = query.associatedentity.type;
          filter.key = filter.name?.replace(
            'asso-' + query.associatedentity.type + '-',
            '',
          );
        } else {
          filter.entity_type = query.entity.type;
          filter.key = filter.name;
        }
        if (filter.data_type == 'date') {
          valueOne = moment(filter.value?.startDate).format(
            globalDateEntity.dateTimeFormatPost,
          );
          if (filter.operator == 'range') {
            value_2 = moment(filter.value?.endDate).format(
              globalDateEntity.dateTimeFormatPost,
            );
          }
        } else if (Array.isArray(filter.value)) {
          valueOne = filter.value?.map((item) => {
            if(item.title !=undefined) return item.title;
            else return item;
          });
          valueOne = valueOne.toString();
        }
        return {
          relation: filter.relation,
          key: filter.key,
          value: valueOne,
          value_2,
          operation: filter.operator,
          entity_type: filter.entity_type,
        };
      });
      reportAction
        .updateCustomReportMetaQuery({ PK: data.PK, data: { query } })
        .then((res) => {
          if(type == 'preview'){
            dispatch({type: ACTIONLIST.RESET_TO_INIT})
            history.push(`/reportresult/custom/${encodeURIComponent(res.data.data.PK)}`);
          }else{
            commonAction.setSubmitSnackbar({
              status: true,
              messages: 'Record Updated',
            });
          }
          
        })
        .catch((err) => {
          commonAction.setSubmitSnackbar({
            status: true,
            messages: 'Error',
            error: true,
          });
        });
    }
  };
  const a11yProps = (index) => {
    try {
      // setting the tabs
      return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
      };
    } catch (err) {
      console.log('err', err);
    }
  };
  return (
    <Grid container>
      <Grid sm item={12}>
        <AppBar position="static">
          <Grid container alignItems="center">
            <Grid item sm={9}>
              <Tabs
                className="tabsHeading"
                value={state.currentTab}
                onChange={(e, value) =>
                  dispatch({ type: ACTIONLIST.UPDATE_TAB, payload: value })
                }
                indicatorColor="secondary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="simple tabs example"
              >
                {['Data', 'Filters'].map((v, k) => {
                  return <Tab key={k} label={v} {...a11yProps(k)} />;
                })}
              </Tabs>
            </Grid>
            <Grid item sm={1}>
              <Button style={{ color: '#fff' }} onClick={()=>executeQuery()}>
                {' '}
                Save
              </Button>
            </Grid>
            <Grid item sm={1}>
              <Button style={{ color: '#fff' }} onClick={()=>executeQuery('preview')}>
                {' '}
                Preview
              </Button>
            </Grid>
          </Grid>
        </AppBar>
      </Grid>
      <Grid item sm={12}>
        <div style={{ display: state.currentTab == 0 ? '' : 'none' }}>
          <DataQuery
            entityList={entityList}
            associationTypeList={associationTypeList}
            state={state}
            dispatch={dispatch}
            data={data}
          />
        </div>
        <div style={{ display: state.currentTab == 1 ? '' : 'none' }}>
          <FilterQuery
            state={state}
            dispatch={dispatch}
            data={data}
            entityList={entityList}
            associationTypeList={associationTypeList}
          />
        </div>
      </Grid>
    </Grid>
  );
};
